{
	"__SOURCE": "check list on https://en.wikipedia.org/wiki/List_of_iPad_models, https://en.wikipedia.org/wiki/List_of_iPhone_models, https://everymac.com/systems/apple/ipad/index-ipad-specs.html, https://everymac.com/systems/apple/iphone/index-iphone-specs.html",
	"Apple-iPad1,1": "iPad",
	"Apple-iPad2,1": "iPad 2 WiFi",
	"Apple-iPad2,2": "iPad 2 Cellular",
	"Apple-iPad2,3": "iPad 2 Cellular",
	"Apple-iPad2,4": "iPad 2 WiFi",
	"Apple-iPad2,5": "iPad mini WiFi",
	"Apple-iPad2,6": "iPad mini Cellular",
	"Apple-iPad2,7": "iPad mini Cellular",
	"Apple-iPad3,1": "iPad 3 WiFi",
	"Apple-iPad3,2": "iPad 3 Cellular",
	"Apple-iPad3,3": "iPad 3 Cellular",
	"Apple-iPad3,4": "iPad 4 WiFi",
	"Apple-iPad3,5": "iPad 4 Cellular",
	"Apple-iPad3,6": "iPad 4 Cellular",
	"Apple-iPad4,1": "iPad Air WiFi",
	"Apple-iPad4,2": "iPad Air Cellular",
	"Apple-iPad4,3": "iPad Air Cellular CN",
	"Apple-iPad4,4": "iPad mini 2 WiFi",
	"Apple-iPad4,5": "iPad mini 2 Cellular",
	"Apple-iPad4,6": "iPad mini 2 Cellular CN",
	"Apple-iPad4,7": "iPad mini 3 WiFi",
	"Apple-iPad4,8": "iPad mini 3 Cellular",
	"Apple-iPad4,9": "iPad mini 3 Cellular CN",
	"Apple-iPad5,1": "iPad mini 4 WiFi",
	"Apple-iPad5,2": "iPad mini 4 Cellular",
	"Apple-iPad5,3": "iPad Air 2 WiFi",
	"Apple-iPad5,4": "iPad Air 2 Cellular",
	"Apple-iPad6,3": "iPad Pro 9.7\" WiFi",
	"Apple-iPad6,4": "iPad Pro 9.7\" Cellular",
	"Apple-iPad6,7": "iPad Pro 12.9\" WiFi",
	"Apple-iPad6,8": "iPad Pro 12.9\" Cellular",
	"Apple-iPad6,11": "iPad 5 WiFi",
	"Apple-iPad6,12": "iPad 5 Cellular",
	"Apple-iPad7,1": "iPad Pro 12.9\" (2nd gen) WiFi",
	"Apple-iPad7,2": "iPad Pro 12.9\" (2nd gen) Cellular",
	"Apple-iPad7,3": "iPad Pro 10.5\" WiFi",
	"Apple-iPad7,4": "iPad Pro 10.5\" Cellular",
	"Apple-iPad7,5": "iPad 6 WiFi",
	"Apple-iPad7,6": "iPad 6 Cellular",
	"Apple-iPad7,11": "iPad 7 WiFi",
	"Apple-iPad7,12": "iPad 7 Cellular",
	"Apple-iPad8,1": "iPad Pro 11\" WiFi",
	"Apple-iPad8,2": "iPad Pro 11\" WiFi",
	"Apple-iPad8,3": "iPad Pro 11\" Cellular",
	"Apple-iPad8,4": "iPad Pro 11\" Cellular",
	"Apple-iPad8,5": "iPad Pro 12.9\" (3rd gen) WiFi",
	"Apple-iPad8,6": "iPad Pro 12.9\" (3rd gen) WiFi",
	"Apple-iPad8,7": "iPad Pro 12.9\" (3rd gen) Cellular",
	"Apple-iPad8,8": "iPad Pro 12.9\" (3rd gen) Cellular",
	"Apple-iPad11,1": "iPad Mini 5 WiFi",
	"Apple-iPad11,2": "iPad Mini 5 Cellular",
	"Apple-iPad11,3": "iPad Air 3 WiFi",
	"Apple-iPad11,4": "iPad Air 3 Cellular",
	"Apple-iPad11,6": "iPad 8 Wifi",
	"Apple-iPad11,7": "iPad 8 Cellular",
	"Apple-iPad12,1": "iPad 9 Wifi",
	"Apple-iPad12,2": "iPad 9 Cellular",
	"Apple-iPad13,1": "iPad Air 4 Wifi",
	"Apple-iPad13,2": "iPad Air 4 Cellular",
	"Apple-iPad13,4": "iPad Pro 11\" (3rd gen) WiFi",
	"Apple-iPad13,5": "iPad Pro 11\" (3rd gen) WiFi",
	"Apple-iPad13,6": "iPad Pro 11\" (3rd gen) Cellular",
	"Apple-iPad13,7": "iPad Pro 11\" (3rd gen) Cellular",
	"Apple-iPad13,8": "iPad Pro 12.9\" (5th gen) WiFi",
	"Apple-iPad13,9": "iPad Pro 12.9\" (5th gen) WiFi",
	"Apple-iPad13,10": "iPad Pro 12.9\" (5th gen) Cellular",
	"Apple-iPad13,11": "iPad Pro 12.9\" (5th gen) Cellular",
	"Apple-iPad13,16": "iPad Air 5 Wifi",
	"Apple-iPad13,17": "iPad Air 5 Cellular",
	"Apple-iPad13,18": "iPad 10 Wifi",
	"Apple-iPad13,19": "iPad 10 Cellular",
	"Apple-iPad14,1": "iPad Mini 6 Wifi",
	"Apple-iPad14,2": "iPad Mini 6 Cellular",
	"Apple-iPad14,8": "iPad Air 11\" M2 Wifi",
	"Apple-iPad14,9": "iPad Air 11\" M2 Cellular",
	"Apple-iPad14,10": "iPad Air 13\" M2 Wifi",
	"Apple-iPad14,11": "iPad Air 13\" M2 Cellular",
	"Apple-iPad15,3": "iPad Air 11\" M2 Wifi",
	"Apple-iPad15,4": "iPad Air 11\" M2 Cellular",
	"Apple-iPad15,5": "iPad Air 13\" M2 Wifi",
	"Apple-iPad15,6": "iPad Air 13\" M2 Cellular",
	"Apple-iPad16,1": "iPad Mini 7 Wifi",
	"Apple-iPad16,2": "iPad Mini 7 Cellular",
	"Apple-iPad16,3": "iPad Pro 11\" M4 Wifi",
	"Apple-iPad16,4": "iPad Pro 11\" M4 Cellular",
	"Apple-iPad16,5": "iPad Pro 13\" M4 Wifi",
	"Apple-iPad16,6": "iPad Pro 13\" M4 Cellular",

	"Apple-iPod1,1": "iPod touch",
	"Apple-iPod2,1": "iPod touch 2",
	"Apple-iPod3,1": "iPod touch 3",
	"Apple-iPod4,1": "iPod touch 4",
	"Apple-iPod5,1": "iPod touch 5",
	"Apple-iPod7,1": "iPod touch 6",
	"Apple-iPod9,1": "iPod touch 7",

	"Apple-iPhone1,1": "iPhone",
	"Apple-iPhone1,2": "iPhone 3G",
	"Apple-iPhone2,1": "iPhone 3GS",
	"Apple-iPhone3,1": "iPhone 4",
	"Apple-iPhone3,2": "iPhone 4",
	"Apple-iPhone3,3": "iPhone 4 CDMA",
	"Apple-iPhone4,1": "iPhone 4S",
	"Apple-iPhone5,1": "iPhone 5",
	"Apple-iPhone5,2": "iPhone 5 CDMA",
	"Apple-iPhone5,3": "iPhone 5c",
	"Apple-iPhone5,4": "iPhone 5c",
	"Apple-iPhone6,1": "iPhone 5s",
	"Apple-iPhone6,2": "iPhone 5s",
	"Apple-iPhone7,1": "iPhone 6 Plus",
	"Apple-iPhone7,2": "iPhone 6",
	"Apple-iPhone8,1": "iPhone 6s",
	"Apple-iPhone8,2": "iPhone 6s Plus",
	"Apple-iPhone8,4": "iPhone SE",
	"Apple-iPhone9,1": "iPhone 7",
	"Apple-iPhone9,2": "iPhone 7 Plus",
	"Apple-iPhone9,3": "iPhone 7",
	"Apple-iPhone9,4": "iPhone 7 Plus",
	"Apple-iPhone10,1": "iPhone 8",
	"Apple-iPhone10,2": "iPhone 8 Plus",
	"Apple-iPhone10,3": "iPhone X",
	"Apple-iPhone10,4": "iPhone 8",
	"Apple-iPhone10,5": "iPhone 8 Plus",
	"Apple-iPhone10,6": "iPhone X",
	"Apple-iPhone11,2": "iPhone XS",
	"Apple-iPhone11,6": "iPhone XS Max",
	"Apple-iPhone11,8": "iPhone XR",
	"Apple-iPhone12,1": "iPhone 11",
	"Apple-iPhone12,3": "iPhone 11 Pro",
	"Apple-iPhone12,5": "iPhone 11 Pro Max",
	"Apple-iPhone12,8": "iPhone SE 2",
	"Apple-iPhone13,1": "iPhone 12 mini",
	"Apple-iPhone13,2": "iPhone 12",
	"Apple-iPhone13,3": "iPhone 12 Pro",
	"Apple-iPhone13,4": "iPhone 12 Pro Max",
	"Apple-iPhone14,2": "iPhone 13 Pro",
	"Apple-iPhone14,3": "iPhone 13 Pro Max",
	"Apple-iPhone14,4": "iPhone 13 mini",
	"Apple-iPhone14,5": "iPhone 13",
	"Apple-iPhone14,6": "iPhone SE 3",
	"Apple-iPhone14,7": "iPhone 14",
	"Apple-iPhone14,8": "iPhone 14 Plus",
	"Apple-iPhone15,2": "iPhone 14 Pro",
	"Apple-iPhone15,3": "iPhone 14 Pro Max",
	"Apple-iPhone15,4": "iPhone 15",
	"Apple-iPhone15,5": "iPhone 15 Plus",
	"Apple-iPhone16,1": "iPhone 15 Pro",
	"Apple-iPhone16,2": "iPhone 15 Pro Max",
	"Apple-iPhone17,1": "iPhone 16 Pro",
	"Apple-iPhone17,2": "iPhone 16 Pro Max",
	"Apple-iPhone17,3": "iPhone 16",
	"Apple-iPhone17,4": "iPhone 16 Plus",
	"Apple-iPhone17,5": "iPhone 16e"
}
